/**
 * Created by Rodrigo Quesada on 16/03/17.
 */
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {UserSearchPageComponent} from './user-search-page.component';
import {PageCommonModule} from '../../shared/page-common.module';
import {FormsModule} from '../../../components/forms/forms.module';
import {UserSearchSectionService} from './model/user-search-section.service';
import {AddProfileModalComponent} from './modals/add-profile-modal.component';

@NgModule({
    imports: [PageCommonModule, FormsModule, NgbModule],
    declarations: [UserSearchPageComponent, AddProfileModalComponent],
    entryComponents: [AddProfileModalComponent],
    providers: [UserSearchSectionService]
})
export class UserSearchPageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/admin/search/user-search-page.module.ts